// Guarda: si el archivo se incluyera más de una vez, no dupliques los
// escuchadores (un doble registro hace que los acordeones abran y cierren
// en el mismo clic).
if (!window.__mtInicializado) {
  window.__mtInicializado = true;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mtInit, { once: true });
  } else {
    mtInit();
  }
}

function mtInit() {
  initReveal();
  initCountUp();
  initTilt();
  initMarquee();
  initParallax();
  initGaleriaProducto();
  initColores();
  initEntrega();
  initVariantesProducto();
  initFaq();
  initBarraCompra();
  initSimulador();
}

// Barra de compra fija: aparece al bajar y se esconde al volver arriba.
function initBarraCompra() {
  var barra = document.querySelector('[data-mt-barra]');
  if (!barra) return;
  var desde = parseInt(barra.dataset.desde || '700', 10);

  function revisar() {
    var mostrar = window.scrollY > desde;
    // Si el pie de página ya está en pantalla, se aparta para no taparlo.
    var pie = document.querySelector('.footer, footer');
    if (mostrar && pie) {
      var caja = pie.getBoundingClientRect();
      var alto = window.innerHeight || document.documentElement.clientHeight;
      if (caja.top < alto - 80) mostrar = false;
    }
    barra.classList.toggle('mt-barra-visible', mostrar);
    barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
  }

  var ultima = 0;
  window.addEventListener('scroll', function () {
    var ahora = Date.now();
    if (ahora - ultima < 90) return;
    ultima = ahora;
    revisar();
  }, { passive: true });
  window.addEventListener('resize', revisar);
  setInterval(revisar, 400);
  revisar();
}

// Simulador de una noche de carga: compara dejar el cargador puesto frente a
// usar el adaptador. Es una demostración ilustrativa, no una medición real.
function initSimulador() {
  var paneles = document.querySelectorAll('[data-mt-sim]');
  if (!paneles.length) return;

  paneles.forEach(function (panel) {
    var boton = panel.querySelector('[data-mt-sim-btn]');
    if (!boton) return;
    var el = {
      rellenoSin: panel.querySelector('[data-mt-sim-relleno="sin"]'),
      rellenoCon: panel.querySelector('[data-mt-sim-relleno="con"]'),
      pctSin: panel.querySelector('[data-mt-sim-pct="sin"]'),
      pctCon: panel.querySelector('[data-mt-sim-pct="con"]'),
      estadoSin: panel.querySelector('[data-mt-sim-estado="sin"]'),
      estadoCon: panel.querySelector('[data-mt-sim-estado="con"]'),
      batSin: panel.querySelector('[data-mt-sim-bateria="sin"]'),
      batCon: panel.querySelector('[data-mt-sim-bateria="con"]'),
      horasSin: panel.querySelector('[data-mt-sim-horas="sin"]'),
      horasCon: panel.querySelector('[data-mt-sim-horas="con"]'),
      calorSin: panel.querySelector('[data-mt-sim-calor="sin"]'),
      calorCon: panel.querySelector('[data-mt-sim-calor="con"]'),
      reloj: panel.querySelector('[data-mt-sim-reloj]'),
      ladoSin: panel.querySelector('.mt-sim-sin'),
      ladoCon: panel.querySelector('.mt-sim-con')
    };

    var estadoSinCargando = el.estadoSin ? el.estadoSin.textContent : '';
    var estadoConCargando = el.estadoCon ? el.estadoCon.textContent : '';
    var estadoSinLleno = panel.getAttribute('data-lleno-sin') || 'Al 100% y sigue enchufado, acumulando calor.';
    var estadoConLleno = panel.getAttribute('data-lleno-con') || 'Al 100%: corriente cortada. Deja de recibir energía.';

    var velocidad = parseInt(panel.dataset.velocidad || '5', 10);
    var HORAS_TOTAL = 8;
    var HORAS_CARGA = 2.5;
    var duracion = 9000 - velocidad * 600; // ms que dura la simulación completa
    var inicio = null;
    var corriendo = false;

    function formatoReloj(horas) {
      var h = Math.floor(horas);
      var m = Math.floor((horas - h) * 60);
      return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
    }

    function pintar(horas) {
      var pct = Math.min(100, Math.round((horas / HORAS_CARGA) * 100));
      var lleno = horas >= HORAS_CARGA;
      var deMas = lleno ? horas - HORAS_CARGA : 0;

      if (el.rellenoSin) el.rellenoSin.style.width = pct + '%';
      if (el.rellenoCon) el.rellenoCon.style.width = pct + '%';
      if (el.pctSin) el.pctSin.textContent = pct + '%';
      if (el.pctCon) el.pctCon.textContent = pct + '%';
      if (el.reloj) el.reloj.textContent = formatoReloj(horas);

      if (el.horasSin) el.horasSin.textContent = deMas.toFixed(1);
      if (el.horasCon) el.horasCon.textContent = '0.0';

      // El calor sube mientras sigue enchufado sin necesidad.
      var calor = Math.min(100, Math.round((deMas / (HORAS_TOTAL - HORAS_CARGA)) * 100));
      if (el.calorSin) el.calorSin.textContent = calor;
      if (el.calorCon) el.calorCon.textContent = '0';

      if (el.batSin) el.batSin.classList.toggle('mt-sim-caliente', lleno);
      if (el.batCon) el.batCon.classList.toggle('mt-sim-cortada', lleno);
      if (el.ladoSin) el.ladoSin.classList.toggle('mt-sim-alerta', lleno);
      if (el.ladoCon) el.ladoCon.classList.toggle('mt-sim-ok', lleno);

      if (el.estadoSin) el.estadoSin.textContent = lleno ? estadoSinLleno : estadoSinCargando;
      if (el.estadoCon) el.estadoCon.textContent = lleno ? estadoConLleno : estadoConCargando;
    }

    function paso(ts) {
      if (inicio === null) inicio = ts;
      var t = Math.min((ts - inicio) / duracion, 1);
      pintar(t * HORAS_TOTAL);
      if (t < 1) {
        requestAnimationFrame(paso);
      } else {
        corriendo = false;
        boton.disabled = false;
      }
    }

    var salvavidas = null;
    function reiniciar() {
      inicio = null;
      corriendo = true;
      boton.disabled = true;
      pintar(0);
      requestAnimationFrame(paso);
      // Si la pestaña se queda en segundo plano el dibujo se pausa; esto evita
      // que el botón se quede bloqueado para siempre.
      if (salvavidas) clearTimeout(salvavidas);
      salvavidas = setTimeout(function () {
        if (!corriendo) return;
        corriendo = false;
        boton.disabled = false;
        pintar(HORAS_TOTAL);
      }, duracion + 4000);
    }

    boton.addEventListener('click', function () {
      if (corriendo) return;
      reiniciar();
    });

    pintar(0);
  });
}


// Aparición de bloques al hacer scroll.
// Se calcula a mano con la posición real de cada bloque (no solo con
// IntersectionObserver): así, si el observador no llega a dispararse en algún
// navegador o pestaña en segundo plano, el contenido NUNCA se queda invisible.
// Además hay una red de seguridad final que lo muestra todo pase lo que pase.
function initReveal() {
  var els = Array.prototype.slice.call(document.querySelectorAll('.mt-reveal'));
  if (!els.length) return;

  function mostrar(el) {
    if (!el.classList.contains('mt-visible')) el.classList.add('mt-visible');
  }

  function revisar() {
    var alto = window.innerHeight || document.documentElement.clientHeight;
    for (var i = els.length - 1; i >= 0; i--) {
      var el = els[i];
      var caja = el.getBoundingClientRect();
      // Se muestra en cuanto su parte superior entra por abajo. No se exige que
      // siga en pantalla: si el visitante baja de golpe, los bloques que quedan
      // por encima también deben quedar visibles.
      if (caja.top < alto - 60) {
        mostrar(el);
        els.splice(i, 1);
      }
    }
    if (!els.length) desconectar();
  }

  // Limitador por tiempo en vez de requestAnimationFrame: rAF se pausa en
  // pestañas en segundo plano y dejaría bloques sin aparecer al volver.
  var ultima = 0;
  function alDesplazar() {
    var ahora = Date.now();
    if (ahora - ultima < 80) return;
    ultima = ahora;
    revisar();
  }

  var temporizador = null;
  function desconectar() {
    window.removeEventListener('scroll', alDesplazar);
    window.removeEventListener('resize', alDesplazar);
    if (temporizador) { clearInterval(temporizador); temporizador = null; }
  }

  window.addEventListener('scroll', alDesplazar, { passive: true });
  window.addEventListener('resize', alDesplazar);
  revisar();
  // Pasadas extra tras el primer pintado (fuentes e imágenes cambian alturas).
  setTimeout(revisar, 120);
  setTimeout(revisar, 500);
  window.addEventListener('load', revisar);
  // Chequeo periódico de respaldo: garantiza que los bloques aparezcan aunque
  // el navegador no entregue eventos de scroll (pestañas restauradas, scroll
  // por teclado o dentro de un iframe). Se apaga solo al mostrarlos todos.
  temporizador = setInterval(revisar, 250);

  // Red de seguridad: si pasados 2,5 s no se ha mostrado NADA, es que el
  // cálculo no está funcionando en este navegador. En ese caso se muestra todo
  // sin animación — mejor una página visible que una página en blanco.
  setTimeout(function () {
    if (document.querySelector('.mt-reveal.mt-visible')) return;
    document.querySelectorAll('.mt-reveal').forEach(mostrar);
    desconectar();
  }, 2500);
}

// Cifras que cuentan hacia arriba al entrar en pantalla.
// Se comprueba la posición a mano y hay red de seguridad: una cifra que se
// quedase en 0 estaría dando un dato FALSO al cliente, así que pase lo que
// pase acaba mostrando su valor real.
function initCountUp() {
  var els = Array.prototype.slice.call(document.querySelectorAll('.mt-count'));
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function valorFinal(el) {
    var target = parseFloat(el.dataset.target || '0');
    var decimals = el.dataset.decimals ? parseInt(el.dataset.decimals, 10) : 0;
    return formatearCifra(target, decimals) + (el.dataset.suffix || '');
  }

  function formatearCifra(n, decimals) {
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  function animar(el) {
    var target = parseFloat(el.dataset.target || '0');
    var suffix = el.dataset.suffix || '';
    var decimals = el.dataset.decimals ? parseInt(el.dataset.decimals, 10) : 0;
    if (reduce) { el.textContent = valorFinal(el); return; }
    var duration = 1400;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatearCifra(target * eased, decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = valorFinal(el);
      }
    }
    requestAnimationFrame(step);
  }

  function revisar() {
    var alto = window.innerHeight || document.documentElement.clientHeight;
    for (var i = els.length - 1; i >= 0; i--) {
      var caja = els[i].getBoundingClientRect();
      if (caja.top < alto - 40) {
        animar(els[i]);
        els.splice(i, 1);
      }
    }
    if (!els.length && temporizador) { clearInterval(temporizador); temporizador = null; }
  }

  var temporizador = setInterval(revisar, 250);
  revisar();

  // Si a los 4 s alguna sigue sin animarse, se escribe su valor directamente.
  setTimeout(function () {
    document.querySelectorAll('.mt-count').forEach(function (el) {
      if (el.textContent.trim() === '0') el.textContent = valorFinal(el);
    });
  }, 4000);
}

function initTilt() {
  var els = document.querySelectorAll('.mt-tilt');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  els.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}

function initParallax() {
  var els = document.querySelectorAll('.mt-parallax');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 990) return;
  var ticking = false;
  function update() {
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var progress = (vh - r.top) / (vh + r.height);
      progress = Math.max(0, Math.min(1, progress));
      var intensity = parseFloat(el.dataset.intensity || '30');
      var offset = (progress - 0.5) * intensity;
      el.style.transform = 'translateY(' + offset + 'px) scale(1.12)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

function initGaleriaProducto() {
  document.querySelectorAll('.mt-prod-thumbs').forEach(function (wrap) {
    var principal = wrap.parentElement.querySelector('.mt-prod-img-principal');
    if (!principal) return;
    wrap.querySelectorAll('[data-mt-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (!full) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = full;
          principal.style.opacity = '1';
        }, 150);
        wrap.querySelectorAll('.mt-prod-thumb').forEach(function (t) { t.classList.remove('mt-prod-thumb-activa'); });
        btn.classList.add('mt-prod-thumb-activa');
      });
    });
  });
}

// Fecha de entrega estimada, calculada desde hoy saltando fines de semana.
// Se recalcula en cada visita, así el mensaje nunca se queda antiguo.
function initEntrega() {
  var nodos = document.querySelectorAll('[data-mt-entrega]');
  if (!nodos.length) return;

  var dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
               'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  function sumarLaborables(desde, n) {
    var f = new Date(desde.getTime());
    var restantes = n;
    while (restantes > 0) {
      f.setDate(f.getDate() + 1);
      var d = f.getDay();
      if (d !== 0 && d !== 6) restantes--;
    }
    return f;
  }

  nodos.forEach(function (nodo) {
    var min = parseInt(nodo.dataset.min || '1', 10);
    var max = parseInt(nodo.dataset.max || '3', 10);
    var hoy = new Date();
    var d1 = sumarLaborables(hoy, min);
    var d2 = sumarLaborables(hoy, max);
    var rango;
    if (d1.getMonth() === d2.getMonth()) {
      rango = 'entre el ' + d1.getDate() + ' y el ' + d2.getDate() + ' de ' + meses[d2.getMonth()];
    } else {
      rango = 'entre el ' + d1.getDate() + ' de ' + meses[d1.getMonth()] +
              ' y el ' + d2.getDate() + ' de ' + meses[d2.getMonth()];
    }
    // Si pides hoy entre semana, se destaca el día de salida.
    var diaHoy = hoy.getDay();
    var texto = (diaHoy !== 0 && diaHoy !== 6)
      ? 'Pídelo hoy ' + dias[diaHoy] + ' y lo recibes ' + rango
      : 'Recíbelo ' + rango;
    var destino = nodo.querySelector('.mt-entrega-texto');
    if (destino) destino.textContent = texto;
  });
}

// Selector de color por muestras: cambia la variante, el precio y la imagen
// del producto sin recargar la página.
function initColores() {
  document.querySelectorAll('.mt-prod-form, .mt-hero-form, .mt-cta-form').forEach(function (form) {
    var grupo = form.querySelector('[data-mt-colores]') || (form.parentElement && form.parentElement.querySelector('[data-mt-colores]'));
    var seccion = form.closest('.mt-section');
    if (!grupo && seccion) grupo = seccion.querySelector('[data-mt-colores]');
    if (!grupo) return;

    var idInput = form.querySelector('[data-mt-variant-id]') || form.querySelector('input[name="id"]');
    var boton = form.querySelector('[data-mt-btn-comprar]') || form.querySelector('button[type="submit"]');
    var btnTexto = form.querySelector('[data-mt-btn-texto]');
    var elegido = grupo.querySelector('[data-mt-color-elegido]');
    var precioEl = seccion ? (seccion.querySelector('.mt-prod-precio-actual') || seccion.querySelector('.mt-hero-precio-actual') || seccion.querySelector('.mt-cta-precio-actual')) : null;
    var precioAntesEl = seccion ? (seccion.querySelector('.mt-prod-precio-antes') || seccion.querySelector('.mt-hero-precio-antes') || seccion.querySelector('.mt-cta-precio-antes')) : null;
    var imgPrincipal = seccion ? seccion.querySelector('.mt-prod-img-principal') : null;
    var imgHero = seccion ? seccion.querySelector('.mt-hero-img') : null;
    var thumbs = seccion ? seccion.querySelectorAll('[data-mt-thumb]') : [];

    var textoAgotado = (boton && boton.dataset.textoAgotado) || 'Agotado';
    var textoDisponible = btnTexto ? btnTexto.textContent.trim() : '';
    var stockEl = grupo.querySelector('[data-mt-stock]');
    var umbral = parseInt(grupo.dataset.umbral || '15', 10);

    function pintarStock(btn) {
      if (!stockEl) return;
      var disponible = btn.dataset.disponible !== '0';
      if (!disponible) {
        stockEl.textContent = 'Sin unidades en este color ahora mismo';
        stockEl.classList.add('mt-colores-stock-agotado');
        stockEl.hidden = false;
        return;
      }
      stockEl.classList.remove('mt-colores-stock-agotado');
      var q = btn.dataset.stock;
      var n = q === undefined ? NaN : parseInt(q, 10);
      if (!isNaN(n) && n > 0 && n <= umbral) {
        stockEl.textContent = n === 1
          ? 'Queda 1 unidad en este color'
          : 'Quedan ' + n + ' unidades en este color';
        stockEl.hidden = false;
      } else {
        stockEl.hidden = true;
      }
    }

    function aplicar(btn) {
      if (idInput && btn.dataset.variante) idInput.value = btn.dataset.variante;
      if (precioEl && btn.dataset.precio) precioEl.textContent = btn.dataset.precio;
      if (precioAntesEl) {
        if (btn.dataset.precioAntes) {
          precioAntesEl.textContent = btn.dataset.precioAntes;
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      var disponible = btn.dataset.disponible !== '0';
      if (boton) {
        boton.disabled = !disponible;
        if (btnTexto) btnTexto.textContent = disponible ? textoDisponible : textoAgotado;
      }
      pintarStock(btn);

      var src = btn.dataset.imagen;
      if (src) {
        cambiarImagen(imgPrincipal, src);
        cambiarImagen(imgHero, src);
        thumbs.forEach(function (t) {
          var full = t.getAttribute('data-full') || '';
          t.classList.toggle('mt-prod-thumb-activa', full.split('?')[0] === src.split('?')[0]);
        });
      }
    }

    function cambiarImagen(img, src) {
      if (!img) return;
      var limpio = src.split('?')[0];
      var actual = (img.currentSrc || img.src || '').split('?')[0];
      if (limpio === actual) return;
      img.style.opacity = '0';
      setTimeout(function () {
        img.src = src;
        img.removeAttribute('srcset');
        img.style.opacity = '1';
      }, 160);
    }

    var inicial = grupo.querySelector('[data-mt-color].mt-color-activo');
    if (inicial) pintarStock(inicial);

    grupo.querySelectorAll('[data-mt-color]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-mt-color]').forEach(function (b) {
          b.classList.remove('mt-color-activo');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('mt-color-activo');
        btn.setAttribute('aria-checked', 'true');
        if (elegido) elegido.textContent = btn.dataset.nombre || btn.dataset.valor;
        aplicar(btn);
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('.mt-prod-form').forEach(function (form) {
    var script = form.querySelector('[data-mt-variantes]');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-mt-option-index]');
    if (!selects.length) return;
    var idInput = form.querySelector('[data-mt-variant-id]');
    var btn = form.querySelector('[data-mt-btn-comprar]');
    var btnTexto = form.querySelector('[data-mt-btn-texto]');
    var section = form.closest('.mt-section');
    var precioEl = section ? section.querySelector('.mt-prod-precio-actual') : null;

    function actualizar() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl && match.price != null) {
        precioEl.textContent = formatearDinero(match.price);
      }
      if (btn) {
        var disponible = match.available;
        btn.disabled = !disponible;
        if (btnTexto) btnTexto.textContent = disponible ? btnTexto.dataset.textoDisponible || btnTexto.textContent : (btn.dataset.textoAgotado || 'Agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function formatearDinero(centavos) {
  return (centavos / 100).toLocaleString(document.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
}

function initFaq() {
  document.querySelectorAll('.mt-faq-item').forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq-pregunta');
    var lista = item.closest('.mt-faq-lista');
    if (!pregunta || !lista) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      lista.querySelectorAll('.mt-faq-item').forEach(function (i) {
        i.classList.remove('mt-faq-abierto');
        var b = i.querySelector('.mt-faq-pregunta');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!abierto) {
        item.classList.add('mt-faq-abierto');
        pregunta.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initMarquee() {
  var wraps = document.querySelectorAll('.mt-marquee-track');
  wraps.forEach(function (track) {
    if (track.dataset.mtCloned) return;
    track.dataset.mtCloned = '1';
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  });
}
